import React from 'react';

/** Revenue widget beside the phone mockup; pass compact for the mobile hero layout */
export default function RevenueRingFloat({ className = '', compact = false }) {
  const r = 17;
  const c = 2 * Math.PI * r;
  const pct = 0.71;

  if (compact) {
    return (
      <div
        className={`w-[100px] rounded-2xl bg-white shadow-[0_16px_36px_-8px_rgba(0,0,0,0.2)] border border-gray-100 px-2 py-2 ${className}`}
      >
        <div className="relative mx-auto h-[46px] w-[46px]">
          <svg viewBox="0 0 44 44" className="h-[46px] w-[46px]">
            <circle cx="22" cy="22" r={r} fill="none" stroke="#e7e5e4" strokeWidth="3.5" />
            <circle
              cx="22"
              cy="22"
              r={r}
              fill="none"
              stroke="#f59e0b"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeDasharray={c}
              strokeDashoffset={c * (1 - pct)}
              transform="rotate(-90 22 22)"
            />
          </svg>
          <span className="absolute inset-0 flex items-center justify-center text-[10px] font-bold text-gray-800">71%</span>
        </div>
        <p className="text-[9px] font-medium text-gray-500 text-center leading-tight mt-1">Total revenue</p>
        <p className="text-[13px] font-bold text-gray-900 text-center tabular-nums leading-none mt-0.5">$3.5k</p>
      </div>
    );
  }

  return (
    <div
      className={`w-[118px] md:w-[128px] rounded-2xl bg-white shadow-[0_22px_48px_-8px_rgba(0,0,0,0.2)] border border-gray-100 px-3 py-3 ${className}`}
    >
      <div className="relative mx-auto h-[58px] w-[58px] md:h-[62px] md:w-[62px]">
        <svg viewBox="0 0 44 44" className="h-[58px] w-[58px] md:h-[62px] md:w-[62px]">
          <circle cx="22" cy="22" r={r} fill="none" stroke="#e7e5e4" strokeWidth="3.5" />
          <circle
            cx="22"
            cy="22"
            r={r}
            fill="none"
            stroke="#f59e0b"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={c * (1 - pct)}
            transform="rotate(-90 22 22)"
          />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-[11px] font-bold text-gray-800">71%</span>
      </div>
      <p className="text-[10px] font-medium text-gray-500 text-center leading-tight mt-1">Total revenue</p>
      <p className="text-[14px] md:text-[15px] font-bold text-gray-900 text-center tabular-nums leading-none mt-0.5">$3.5k</p>
    </div>
  );
}
